// extracted by mini-css-extract-plugin
module.exports = {"footerWrap":"dsInput_footerWrap__Iz868","input":"dsInput_input__r0S5L","ant-input-focused":"dsInput_ant-input-focused__dYlY7","uploadsWrap":"dsInput_uploadsWrap__wUAb7"};